/** Возвращает текущий месяц в формате "YYYY-MM" */
export function getCurrentMonth(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

/** Список последних 24 месяцев для выпадающего списка периодов */
export function getMonthsList(): { value: string; label: string }[] {
  const list: { value: string; label: string }[] = [];
  const now = new Date();
  for (let i = 0; i < 24; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    const raw = d.toLocaleString('ru', { year: 'numeric', month: 'long' });
    list.push({ value, label: raw.charAt(0).toUpperCase() + raw.slice(1) });
  }
  return list;
}

/** Форматирует сумму с единицей измерения (₸), сокращает крупные числа */
export function fmtSum(v: number): string {
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(2)} М ₸`;
  if (v >= 1_000) return `${(v / 1_000).toFixed(1)} К ₸`;
  return `${Math.round(v)} ₸`;
}

/** Форматирует дату ISO → ДД.ММ.ГГГГ */
export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('ru-RU');
}

/**
 * Возвращает цвет и лейбл для срока годности.
 * < 30 дней → красный, < 90 дней → оранжевый, иначе → зелёный
 */
export function getExpiryMeta(expiryDate: string | null | undefined): {
  color: string;
  bgcolor: string;
  label: string;
  daysLeft: number;
} {
  if (!expiryDate) return { color: '#6b7280', bgcolor: 'transparent', label: '-', daysLeft: Infinity };
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const exp = new Date(expiryDate);
  const daysLeft = Math.ceil((exp.getTime() - now.getTime()) / 86_400_000);
  if (daysLeft < 0) return { color: '#dc2626', bgcolor: 'rgba(220,38,38,0.08)', label: 'Просрочен', daysLeft };
  if (daysLeft < 30) return { color: '#dc2626', bgcolor: 'rgba(220,38,38,0.08)', label: `${daysLeft} дн.`, daysLeft };
  if (daysLeft < 90) return { color: '#d97706', bgcolor: 'rgba(217,119,6,0.08)', label: `${daysLeft} дн.`, daysLeft };
  return { color: '#16a34a', bgcolor: 'rgba(22,163,74,0.08)', label: `${daysLeft} дн.`, daysLeft };
}
